module.exports = __webpack_public_path__ + "static/img/4.97499fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/4.png
// module id = ia82
// module chunks = 0